let faqs = document.querySelectorAll('.faq')

if(faqs.length) {
    for(let faq of faqs) {
        let items = faq.querySelectorAll('.faq-item')

        if(items.length) {
            for(let item of items) {
                let header = item.querySelector('.faq-item-title')

                header.addEventListener('click', () => {
                    item.classList.toggle('active')
                })
            }
        }
    }
}